import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: loadStoredLanguage(),
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});

Vue.prototype.$locale = {
  changeIfRequired(lang) {
    if (lang != null && i18n.locale !== lang) {
      // set new language
      i18n.locale = lang;
      return true;
    }
    return false;
  },
  current() {
    return i18n.locale;
  },
};

// Load json files with translations
function loadLocaleMessages() {
  if (process.env.VUE_APP_SLOT === "TEST") {
    // not in test env -> jest has problems with require.context
    return;
  }
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

function loadStoredLanguage() {
  let lang = localStorage.getItem("kisme.lang");
  if (lang == null) {
    lang = "en";
  }
  return lang;
}

export default i18n;
